export default __webpack_public_path__ + "static/media/ownership_closed_block.a94b2c28.svg";